import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';

/**
 * Guards /school-admin — only renders children if the authenticated user
 * has role="school_admin". Platform admins also pass through (super-user).
 */
export default function SchoolAdminRoute({ children }) {
  const navigate = useNavigate();
  const [state, setState] = useState('checking');

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/auth/me');
        const role = (data?.role || '').toLowerCase();
        if (role === 'school_admin' || (role === 'platform_admin' && data?.is_platform_admin)) {
          setState('allowed');
        } else {
          setState('denied');
          navigate('/', { replace: true });
        }
      } catch {
        setState('denied');
        localStorage.removeItem('yukti_session_token');
        navigate('/', { replace: true });
      }
    })();
  }, [navigate]);

  if (state === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div
            className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600 mx-auto mb-3"
            data-testid="school-admin-loading-spinner"
          />
          <p className="text-sm text-gray-600">Verifying access…</p>
        </div>
      </div>
    );
  }
  if (state === 'denied') return null;
  return children;
}
